import { Component } from '@angular/core'
import { images } from './preload-img'

@Component({
  selector: 'app-preload-img',
  template: `@for (img of images; track img) {<img hidden [src]="img" />}`
})
export class PreloadImgComponent {
  images = images
}
